import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import SellingPriceHistoryContainer from "@/screens/Pricing/containers/SellingPriceHistoryContainer"
import { priceChangeHistorySearchSchema } from "@/screens/Pricing/types/searchParams"

export const Route = createFileRoute("/app/pricing/_layout/history/price-change")({
  component: () => (
    <PermissionContentWrapper
      permissions={[
        PermissionActionType.PRICING_VIEW,
        PermissionActionType.PRICING_MANAGER,
        PermissionActionType.PRICING_MAINTENANCE,
      ]}
    >
      <SellingPriceHistoryContainer />
    </PermissionContentWrapper>
  ),
  validateSearch: zodValidator(priceChangeHistorySearchSchema),
})
